import {NgModule, Component, OnInit, OnDestroy, Input} from '@angular/core'; // , Injector , Input, Output
import { SocketService } from '../../services/socket.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SharedPipeChatModule } from '../../shared/shared.pipe.chat.module';
import { UserInfoModule } from '../../components/userInfo';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';
import { AuthService } from '../../services/auth.service';
import { DialogService } from '../../services/dialog.service';
import { EventService } from '../../services/event.service';

@Component({
    selector: 'chat-room-view',
    template: `
        <!-- chat_box -->
        <div class="chat_box">
            <div class="chat_list scroll" [ngStyle]="{height: (dynamicHeight) + 'px'}" >
                <div class="inr">
                    <p *ngFor="let message of messages">
                        <span><img [src]="'assets/images/common/lv/' + message.user.mb_lv + '.png'" alt="" class="lvS1"></span>
                        {{message.user.mb_nick}}
                        <em [ngStyle]="{'color': message.color ? message.color: ''}">{{message.msg}}</em>
                    </p>
                </div>
            </div>
            <div class="chat-input chat-input_v2">
                <div class="chat_btn">
                    <ul>
                        <!-- [D] 참여자인 경우 -->
                        <li *ngIf="!isCreator"><a (click)="sendPointAsGift()">포인트선물</a></li>
                        <li *ngIf="!isCreator"><a (click)="setRecommend()">추천</a></li>
                        <li *ngIf="!isCreator"><a (click)="claim()">신고</a></li>
                        <!-- <li><a>나가기</a></li> -->
                        <!-- [D] 방장인 경우 -->
                        <li *ngIf="isCreator && !roomInfo.freeze" (click)="setFreeze(true)"><a>채팅방 얼리기</a></li>
                        <li *ngIf="isCreator && roomInfo.freeze" (click)="setFreeze(false)"><a>채팅방 녹이기</a></li>
                        <li *ngIf="isCreator" (click)="close_room()"><a>채팅방 닫기</a></li>
                    </ul>
                </div>
                <div class="chat-input layout-row">
                    <div class="input">
                        <mat-form-field>
                            <input matInput [(ngModel)]="data.message" name="message" placeholder="이곳에 채팅을 입력해주세요." required><!-- on-focus="inputUp()"
                                on-blur="inputDown()" closeKeyboard() on-enter="sendMessage()"  -->
                        </mat-form-field>
                    </div>
                    <button mat-button aria-label="메시지 전송" class="mat-mat-button mat-button" (click)="sendMessage();">전송</button>
                </div>
            </div>
        </div>
        <!-- // chat_box -->
`
})


export class ChatRoomViewComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject();
    // showNum = 0;
    messages = []; // 채팅 내용;
    // data: any = {message: ''};
    dynamicHeight = 300;
    // sockConnection = new Array();
    roomInfo: any;
    roomId: string; // = $stateParams.roomId;
    chatId: string; // = $stateParams.chatId;
    isCreator = false; // 방장여부 확인
    me: any;


    data: any = {message: ''}; // 메시지 전송용

    @Input() set resizeObject(resizeData: {edges: any, rectangle: any }) {
        if (!resizeData.rectangle) {
            return;
        }

        const rectangleHeight = resizeData.rectangle.height - 78;
        this.dynamicHeight = rectangleHeight;
    }

    @Input() set selectedChatIndex(index: number) {
        if (index === 3) {
        }
    }

    @Input() set chatroomView(obj: any) {

        if (typeof obj !== 'undefined') {
            this.chatId = obj.room_id;
        }

        this.socketService.leaveRoom(''); // 찬스톡에 의해 세팅된 각각의 방을 떠난다.
        // 기존
        this.check_enter_room();
    }

    constructor(
        private socketService: SocketService,
        private http: HttpService,
        protected toasterService: ToasterService,
        protected authService: AuthService,
        protected dialogService: DialogService,
        protected eventService: EventService
    ) {
                    // private injector: Injector
            this.authService.mustLoggedIn();
            this.me = authService.getUser();
    }

    ngOnInit() {
        // console.log('ngOnInit');
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    private check_enter_room() {
        this.init(); // 각종 소켓에 대한 정보를 초기화 한다.

        // 현재방에 들어 올 수 있는 권한 등이 있는지 확인 후 처리
        const preParams = {roomid: this.chatId};
        this.http.get({url: 'chat/before-enter-chatRoom', params: preParams}).then((obj) => {
            if (obj.result) { // 소켓에 전송한다.
                this.socketService.addRoom(this.chatId);
                this.socketService.Emit('refreshChatHistory', {chatRoom : this.chatId});

                this.get_room_info();

            } else {
                this.toasterService.showToaster('error', obj.message);
            }
        });

    }



    private init() {
        // 채팅 내용 히스토리 받기 시작
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('chatList')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                req.reverse();
                this.messages = [];
                for (const reqObj of req) {
                    const tmpObj = JSON.parse(reqObj);
                    this.messages.push(tmpObj);
                }
            })
        );

        /**
         * 메시지를 받은 후 현재 리스트에 추가한다.
         * {thread_id, message, user_id, username, thumbnail_image, created_at }
         */
        this.socketService.sockConnection.chatRoomView.push(
             this.socketService.On('receiveMessage')
             .pipe(takeUntil(this.ngUnsubscribe))
             .subscribe(obj => {
                const req: any = obj[0];
                this.messages.push(req);
            //    this.message_template(req);

            //    $timeout(function() {
                //    $ionicScrollDelegate.$getByHandle('chatScroll').scrollBottom();
                // }, 30);
             })
         );

        /**
         * 경고 메시지 출력
         * 채팅장이 얼려져 있습니다.
         */
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('alertMessage')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {

                const req: any = obj[0];
                if (req.code === '001') { // 채팅창이 얼려져 있습니다.
                     // $(".chatList").append('<p class="chatbox_ice">' + req.message + '</p>');
                     const chatList = '<p class="chatbox_ice">' + req.message + '</p>';
                     // this.messages += chatList;
                 }  else {
                    this.toasterService.showToaster('info', req.message);
                }
            })
        );


        // room에 대한 다양한 전송은 이것하나로 처리한다.
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('roomNotice')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                switch (req.message) {
                    case 'refreshRoomExtend':
                    // 기간을 각각 연장한다.(추후 필요시 프로그램)
                    break;
                    case 'creatorPick': // 사용자 픽등록
                        // creatorPickRegInfo(req.data);
                    break;
                }
            })
        );



        /**
         * 채팅방에 들어올 경우 (not public)
         * 기존 방에 존재 했던 경우라면 입장메시지를 출력하지 않는다.
         */
        this.socketService.sockConnection.chatRoomView.push(
             this.socketService.On('enter_room')
             .pipe(takeUntil(this.ngUnsubscribe))
             .subscribe(obj => {
                 const req: any = obj[0];
                // if (typeof (chatRoom) !== 'undefined' && typeof (req.mb_nick) !== 'undefined' && req.mb_nick !== '') {
                    // let html = '<p class="chatbox_ok">' + req.mb_nick + '님이 입장하셨습니다.</p>';
                    // $(".chatList").append(html);
                    // scroll_bottom();
                // }

                // 현재 방장이면 방장 포인트를 새로 갱신한다.
                // if (_objRoom.creator_id === _CHAT_VAR.mb_id) {
                    // $.get('/lib/ajax.class.member.php?action=my-info', {}, function(data) {
                    //    let obj = JSON.parse(data);
                    //    $('.chatBtn .my_point strong').html(number_format(obj.mb_point));
                    // });
                // }
            })
        );

        // 채팅방 퇴장
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('leave_room')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                // let html = '<p class="chatbox_gray">' + req.mb_nick + '님이 퇴장하셨습니다.</p>';
                // $(".chatList").append(html);
                // scroll_bottom();
            })
        );

        // 채팅방 종료
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('removed_room')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                // let html = '<p class="chatbox_gray">방장님이 채팅방을 종료하였습니다.</p>';
                // $('.chatList').append(html);
                // scroll_bottom();
                // go_lobby();
            })
        );

        /**
         * 얼리고 푸는 결과 받기
         * @param Object { bool, chatRoom }
         */
        this.socketService.sockConnection.chatRoomView.push(
             this.socketService.On('resultOfSetFreeze')
             .pipe(takeUntil(this.ngUnsubscribe))
             .subscribe(obj => {
                const req: any = obj[0];

                if (req.bool) {
                //    this.messages +=  '<p class="chatbox_ice">방장이 채팅방을 얼렸습니다.</p>';
                    this.roomInfo.freeze = true;
                } else {
                //    this.messages +=  '<p class="chatbox_hot">방장이 채탕방을 녹였습니다.</p>';
                    this.roomInfo.freeze = false;
                }

                // $timeout(function() {
                //    $ionicScrollDelegate.$getByHandle('chatScroll').scrollBottom();
            //    }, 30);
            })
        );

        // 채팅방 종료
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('removed_room')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                // this.messages +=  '<p class="chatbox_gray">방장님이 채팅방을 종료하였습니다.</p>';
                // $ionicScrollDelegate.$getByHandle('chatScroll').scrollBottom();
            //    this.$emit('minichatActivate', "@chatroom");
            })
        );

        // 추천 받아오기
        this.socketService.sockConnection.chatRoomView.push(
            this.socketService.On('get_recommend')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];

                //    $(".recommend_count").html(obj.cnt);

            })
        );


    }
    /**
     * 방정보 가져오기
     */
    private get_room_info() {
        this.http.get({url: 'chat/get-chatRoom', params: {room_id: this.chatId}}).then((obj) => {
            if (obj.result === false) {
                // toaster.pop('error', '알림', obj.message);
            } else {
                this.roomInfo = obj.data;
                if (obj.data.creater.mb_id === this.me.mb_id) { this.isCreator = true; }
            }
        });

    }
/*
    private message_template = function(obj) {
        // let chat_message = $filter('chatUserInfo')(obj);
        let chatList = '';
            chatList += '<p><span><img src="'assets/images/common/lv/' + obj.user.mb_lv + '.png'" alt="" class="lvS1"></span>';
            chatList += obj.user.mb_nick;
            if (typeof (obj.color) === "undefined" || obj.color === "") {
                chatList += '<em>' + obj.msg + '</em>';
            } else {
                chatList += '<em style="color: ' + obj.color + '">' + obj.msg + '</em>';
            }
            chatList += '</p>';

        // this.messages += '<p>' + chat_message + '</p>';
        this.messages += chatList;
    };
*/


    /**
     * 메시지 전송하기
     */
    sendMessage() {
        const data = {};
        const message = this.data.message;
        if (message === '') {
            return;
        }

        this.http.get({url: 'mypage/chat_prohibit_status'}).then((obj) => {
            if (obj.result === false) {
                this.toasterService.showToaster('error', obj.message);
            } else {

                const messageObj: any = {chatRoom: this.chatId, msg: message, room_type: 'chatroom'};
                if (typeof (messageObj.color) === 'undefined') {
                    messageObj.color = '';
                }
                this.socketService.Emit('setMessage', messageObj);
            }
        });
        delete this.data.message;
    }

    // 채팅방 > 포인트선물
    sendPointAsGift() {
        // 자식 컨트롤러에서 $toUser를 받을 수 있도록 현재 방장을 $toUser로 세팅한다.
        const obj = {type: 'popup', component: 'point-gift', params: {to_user: this.roomInfo.creater.mb_id}};
        this.eventService.broadcast('popup', obj);
    }

    // 채팅방 > 신고하기
    claim() {
        // 팝업쪽으로 메시지 전달

        const obj = {type: 'popup', component: 'claim-create', params: {group: 'chat', board: this.chatId}};
        this.eventService.broadcast('popup', obj);
    }

    /**
     * 현재방 추천하기
     */
    setRecommend() {
        this.socketService.Emit('set_recommend', {roomid: this.chatId}); // get_recommend
    }

    // 채팅방닫기 (방장만 가능)
    close_room() {
        this.dialogService
        .confirm('알림', '현재 채팅방을 닫으시겠습니까?')
        // .subscribe(res => this.result = res);
        .subscribe(res => {
            // let my_data: any = obj;

            if (res === true) {
                this.socketService.Emit('remove_room', {roomid: this.chatId}); // get_recommend
            }
        });
    }

    /**
     * 채칭방 얼리기
     * resultOfSetFreeze 로 리턴
     */
    setFreeze(bool: boolean) {
        this.socketService.Emit('setFreeze', {bool, chatRoom: this.chatId}); // get_recommend
    }

}

@NgModule({
    declarations: [ ChatRoomViewComponent ],
    imports: [ CommonModule, FormsModule, MatFormFieldModule, MatInputModule, UserInfoModule, SharedPipeChatModule],
    exports: [ ChatRoomViewComponent ]
})
export class ChatRoomViewModule {}
